import { render, staticRenderFns } from "./widgetMarquee.vue?vue&type=template&id=72349dbd&scoped=true"
import script from "./widgetMarquee.vue?vue&type=script&lang=js"
export * from "./widgetMarquee.vue?vue&type=script&lang=js"
import style0 from "./widgetMarquee.vue?vue&type=style&index=0&id=72349dbd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72349dbd",
  null
  
)

export default component.exports